import { useState } from "react";

import { Button } from "./button.js";

interface RefreshableQuery {
  readonly refetch: () => Promise<unknown>;
}

export function RefreshButton({ queries }: { readonly queries: readonly RefreshableQuery[] }) {
  const [refreshing, setRefreshing] = useState(false);

  const refresh = async () => {
    setRefreshing(true);
    await Promise.allSettled(queries.map((query) => query.refetch()));
    setRefreshing(false);
  };

  return (
    <Button disabled={refreshing} onClick={() => void refresh()} tone="quiet" type="button">
      {refreshing ? "Refreshing…" : "Refresh"}
    </Button>
  );
}
